"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _halfImage = _interopRequireDefault(require("./half-image"));
var _halfText = _interopRequireDefault(require("./half-text"));
var _textBoxWithImage = _interopRequireDefault(require("./text-box-with-image.css"));
var TextBoxWithImage = function TextBoxWithImage(_ref) {
  var _clsx;
  var market = _ref.market,
    theme = _ref.theme,
    data = _ref.data;
  var disclaimerData = data.disclaimerData,
    carAlignment = data.carAlignment;
  var classImageAligment = carAlignment === 'right' ? _textBoxWithImage["default"].alignImageRight : _textBoxWithImage["default"].alignImageLeft;
  var classTextAligmentClass = function classTextAligmentClass() {
    if (carAlignment === 'center') {
      return _textBoxWithImage["default"].alignTextCenter;
    }
    return carAlignment === 'right' ? _textBoxWithImage["default"].alignTextRight : _textBoxWithImage["default"].alignTextLeft;
  };
  var classTextAligment = classTextAligmentClass();
  var hasText = !!(data != null && data.textBlock);
  var hasImage = !!(data != null && data.image.image);
  var getOneOne = function getOneOne(type) {
    if (type === 'text') {
      return 'col-sm-6';
    }
    return 'col-sm-6';
  };
  var getThreeTwo = function getThreeTwo(type) {
    if (type === 'img') {
      return 'col-sm-8';
    }
    if (type === 'text') {
      return 'col-sm-4';
    }
    return '';
  };
  var getColSize = function getColSize(aspect, type) {
    if (aspect === 'ThreeTwo') {
      return getThreeTwo(type);
    }
    if (aspect === 'OneOne') {
      return getOneOne(type);
    }
    if (aspect === 'FourThree') {
      return getOneOne(type);
    }
    if (aspect === 'TextALone') {
      return 'col-sm-12';
    }
    return 'col-sm-6';
  };
  var getClassAspectRatio = function getClassAspectRatio(aspect) {
    if (aspect === 'ThreeTwo') {
      return 'ThreeTwoContainer';
    }
    if (aspect === 'OneOne') {
      return 'OneOneContainer';
    }
    if (aspect === 'FourThree') {
      return 'FourThreeContainer';
    }
    return '';
  };
  var getClassFullcontainerAspectRatio = function getClassFullcontainerAspectRatio(aspect) {
    if (aspect === 'ThreeTwo') {
      return 'ThreeTwoFullContainer';
    }
    if (aspect === 'OneOne') {
      return 'OneOneFullContainer';
    }
    if (aspect === 'FourThree') {
      return 'FourThreeFullContainer';
    }
    return '';
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx2["default"])(theme['container-fluid'], _textBoxWithImage["default"].noGutters, _textBoxWithImage["default"][data.size], (_clsx = {}, _clsx[_textBoxWithImage["default"].dark] = data.theme === 'dark', _clsx), _textBoxWithImage["default"].textBoxWithImage, _textBoxWithImage["default"][getClassFullcontainerAspectRatio(data.aspectRatio)]),
    id: data.heading1
  }, hasImage ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx2["default"])(theme['col-xs-12'], theme['first-xs'], theme['last-sm'], theme[getColSize(data.aspectRatio, 'img')], _textBoxWithImage["default"][getClassAspectRatio(data.aspectRatio)], _textBoxWithImage["default"].noGutters, _textBoxWithImage["default"].carRight, classImageAligment)
  }, /*#__PURE__*/_react["default"].createElement(_halfImage["default"], {
    data: data,
    aspectRatio: data.aspectRatio,
    theme: theme,
    hasText: hasText
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx2["default"])(theme['col-xs-12'], theme[getColSize(data.aspectRatio, 'text')], _textBoxWithImage["default"][getClassAspectRatio(data.aspectRatio)], _textBoxWithImage["default"].noGutters, _textBoxWithImage["default"].textWrap, _textBoxWithImage["default"].textBoxWithImageFont, classTextAligment)
  }, /*#__PURE__*/_react["default"].createElement(_halfText["default"], {
    data: data,
    theme: theme,
    disclaimerData: disclaimerData,
    market: market,
    hasText: hasText
  }))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx2["default"])(theme['col-xs-12'], theme[getColSize('TextALone', 'text')], _textBoxWithImage["default"][getClassAspectRatio(data.aspectRatio)], _textBoxWithImage["default"].noGutters, _textBoxWithImage["default"].textWrap, _textBoxWithImage["default"].textBoxWithImageFont, _textBoxWithImage["default"].textBoxWithImageFontAlone, classTextAligment)
  }, /*#__PURE__*/_react["default"].createElement(_halfText["default"], {
    data: data,
    theme: theme,
    disclaimerData: disclaimerData,
    market: market,
    hasText: hasText
  })));
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    market: props.market || state.Config.market,
    language: props.language || state.Config.language
  };
};
TextBoxWithImage.resourceType = function () {
  return 'TextBlockWithImage_1_0_0';
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(TextBoxWithImage);
exports["default"] = _default;